import React from "react";

const DriverFooter = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-gradient-to-b from-blue-900 to-blue-950 text-white mt-auto">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12 mb-8">
          
          {/* Brand Section */}
          <div className="sm:col-span-1">
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">Aero View Driver</h3>
            <p className="text-xs sm:text-sm text-gray-300 leading-relaxed mb-4">
              Professional vehicle booking platform for drivers at Colombo Dockyard PLC. Stay connected and maximize earnings.
            </p>
            <p className="text-xs text-gray-400">
              Safe, reliable, and efficient transportation solutions.
            </p>
          </div>

          {/* Key Features */}
          <div>
            <h4 className="text-sm sm:text-base font-bold mb-3 sm:mb-4 text-white">Key Features</h4>
            <ul className="space-y-2 text-xs sm:text-sm text-gray-300">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Online/Offline Toggle</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Accept & Manage Bookings</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Real-time Trip Tracking</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Earnings Dashboard</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Customer Communication</span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm sm:text-base font-bold mb-3 sm:mb-4 text-white">Resources</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <a href="#help" className="text-gray-300 hover:text-white hover:underline transition-colors duration-200">
                  Driver Support
                </a>
              </li>
              <li>
                <a href="#safety" className="text-gray-300 hover:text-white hover:underline transition-colors duration-200">
                  Safety Guidelines
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-300 hover:text-white hover:underline transition-colors duration-200">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#privacy" className="text-gray-300 hover:text-white hover:underline transition-colors duration-200">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#terms" className="text-gray-300 hover:text-white hover:underline transition-colors duration-200">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="text-sm sm:text-base font-bold mb-3 sm:mb-4 text-white">Get Help</h4>
            <address className="not-italic text-xs sm:text-sm space-y-2 text-gray-300">
              <p>
                <span className="font-semibold">Colombo Dockyard PLC</span><br />
                Colombo, Sri Lanka
              </p>
              <p>
                <span className="font-semibold">24/7 Support:</span><br />
                <a href="tel:+94112345678" className="hover:text-white transition-colors duration-200">
                  +94 (11) 234 5678
                </a>
              </p>
              <p>
                <span className="font-semibold">Email:</span><br />
                <a href="mailto:drivers@aerovview.lk" className="hover:text-white transition-colors duration-200">
                  drivers@aeroview.lk
                </a>
              </p>
            </address>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-blue-800 my-6 sm:my-8"></div>

        {/* Footer Bottom */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs sm:text-sm text-gray-400">
          <p>
            &copy; {currentYear} <span className="font-semibold text-gray-300">Colombo Dockyard PLC</span>. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="px-3 py-1.5 sm:px-4 sm:py-2 bg-blue-800 hover:bg-blue-700 text-white rounded transition-colors duration-200 text-xs sm:text-sm"
            aria-label="Back to top"
          >
            ↑ Top
          </button>
        </div>
      </div>
    </footer>
  );
};

export default DriverFooter;
